<template>
  <div>
    <!-- button -->
    <b-button
      id="toggle-btn"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal="'modal-lesson' + id"
      variant="outline-primary"
    >
      +
    </b-button>

    <!-- modal data -->

    <!-- modal -->
    <b-modal
      :id="'modal-lesson' + id"
      :ref="'modal-lesson' + id"
      title="Add new Lesson"
      ok-title="Create"
      cancel-variant="outline-secondary"
      size="xl"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <validation-observer ref="lessonInfoRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">lesson Details</h5>
              <small class="text-muted"> Enter the lesson Details. </small>
            </b-col>
            <b-col md="6">
              <b-form-group label="title" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  name="title"
                  rules="required|min:3"
                >
                  <b-form-input
                    id="title"
                    v-model="lesson.title"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Lesson title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="lesson type" label-for="lessontype">
                <validation-provider
                  #default="{ errors }"
                  name="lesson type"
                  rules="required"
                >
                  <b-form-select
                    id="lessontype"
                    :state="errors.length > 0 ? false : null"
                    v-model="lesson.type"
                    :options="options"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="lesson Cover Image"
                label-for="CorseCoverImage"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CorseCoverImage"
                >
                  <b-form-file
                    id="CorseCoverImage"
                    accept="image/*"
                    v-model="lesson.imageCover"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Content" label-for="Content">
                <validation-provider
                  #default="{ errors }"
                  name="Content"
                  rules="required|min:20"
                >
                  <b-form-textarea
                    id="Content"
                    placeholder="Content"
                    v-model="lesson.description"
                    :state="errors.length > 0 ? false : null"
                    rows="8"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import lessonsApi from "@/apiServices/lessonsApi";
import imagesApi from "@/apiServices/imagesApi";
import { required, email, max_value, numeric } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal-lesson": VBModal,
    Ripple,
  },
  props: ["id"],

  data: () => ({
    required,
    email,
    max_value,
    numeric,
    name: "",
    nameState: null,
    options: ["video", "pdf", "powerpoint"],
    submittedNames: [],
    lesson: {
      title: "",
      description: "",
      type: "",
      imageCover: null,
    },
  }),
  methods: {
    createLessons(lessonFormData) {
      lessonsApi.createLesson(lessonFormData).then((response) => {
        if (response.data) {
          console.log(response.data);
          this.lesson = {};
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "lesson Created complite adding the sections and lessons",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },

    createLessonValidation() {
      return new Promise((resolve, reject) => {
        this.$refs.lessonInfoRules.validate().then((success) => {
          if (success) {
            const lessonFormData = new FormData();
            // Object.entries(this.lesson).forEach(([key, value]) => {
            //   lessonFormData.append(key, value);
            // });
            const imageFormData = new FormData();
            imageFormData.append("image", this.lesson.imageCover);

            if (this.lesson.imageCover instanceof File) {
              imagesApi.uploadImage(imageFormData).then((response) => {
                console.log(response);
                this.lesson.imageCover = response;
                this.createLessons(this.lesson);
                this.$refs["my-modal"].toggle("#toggle-btn");
                this.lesson = {};
              });
            } else {
              this.lesson.imageCover =
                "https://res.cloudinary.com/ddr7izjrv/image/upload/v1678128321/ugr0jnxof5xon4uvtnsy.jpg";
              this.createLessons(this.lesson);
            }

            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.createLessonValidation();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs["my-modal-lesson"].toggle("#toggle-btn");
      });
    },
  },
};
</script>
